import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import style from './style.scss';
import { Subhead, Hero } from '@xo-union/tk-ui-typography';
import { DisplayLink } from '@xo-union/tk-ui-links';
import GuidanceModule from './guidance-module';
import PropTypes from 'prop-types';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import AnalyticsStore from '~/glm/models/analytics-store';
import { inject } from 'mobx-react';
import UserStore from '~/glm/models/user-store';

@inject('userStore', 'gdsUiState', 'analyticsStore')
class ZeroState extends Component {
  onCopyFormLink = () => {
    const { wedding } = this.props.userStore;
    const url = `${window.location.origin}/ac/${wedding.vanityUrl || wedding.slug}`;
    //copy Address Collection url to clipboard
    const el = document.createElement('textarea');
    el.value = url;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);

    // shows snackbar
    this.props.gdsUiState.showSnackbar('Link copied! Send it to guests so they can add themselves to your guest list.');

    const view = this.gdsUiState?.selectedEvent ? 'Selected Event' : 'All Events';

    this.props.analyticsStore.track('Dashboard Interaction', {
      action: 'GLM ZeroState Interaction',
      decisionArea: 'copy form link cta',
      view: view,
    });
  };

  goToImportPage = () => {
    const { gdsUiState, analyticsStore, history } = this.props;
    gdsUiState.setImportSpreadsheetView(true);
    const view = this.gdsUiState?.selectedEvent ? 'Selected Event' : 'All Events';
    analyticsStore.track('Dashboard Interaction', {
      action: 'GLM ZeroState Interaction',
      decisionArea: 'add multiple cta',
      view: view,
    });
    history.push('/our-guest-list/import-spreadsheet');
  };

  openGuestModal = () => {
    const { gdsUiState, analyticsStore } = this.props;
    gdsUiState.setShowHouseholdForm(true);
    const view = this.gdsUiState?.selectedEvent ? 'Selected Event' : 'All Events';
    analyticsStore.track('Dashboard Interaction', {
      action: 'GLM ZeroState Interaction',
      decisionArea: 'add guest cta',
      view: view,
    });
  };

  render() {
    const getText = () => ({
      title: 'Collect addresses',
      buttonText: 'Copy form link',
    });

    const { title, buttonText } = getText();

    const renderAddressCollectionLink = () => {
      return (
        <div>
          {'Send guests a link to an '}
          <DisplayLink href="/our-guest-list/address-collection" color="secondary" size="md" target="_blank">
            address collection form
          </DisplayLink>
          {' that adds their info to your guest list.'}
        </div>
      );
    };

    return (
      <div className={style.zeroStateContainer}>
        <div className={style.zeroStateHeader}>
          <Hero size="sm" as="h3">
            Let&apos;s start your guest list
          </Hero>
          <Subhead className={style.subtitle}>
            Add guests in one of three ways to easily keep all your guest info and RSVPs organized:
          </Subhead>
        </div>
        <div className={style.guidanceModuleContainer}>
          <GuidanceModule title="Add guests one by one" buttonText="Add a guest" buttonOnClick={this.openGuestModal}>
            Type your guests’ contact info directly onto your guest list.
          </GuidanceModule>
          <GuidanceModule
            title="Use a spreadsheet"
            buttonText="Add multiple guests"
            buttonOnClick={this.goToImportPage}
          >
            {'Already have a list? Use a spreadsheet template to quickly add multiple guests.'}
          </GuidanceModule>
          <GuidanceModule title={title} buttonText={buttonText} buttonOnClick={this.onCopyFormLink}>
            {renderAddressCollectionLink()}
          </GuidanceModule>
        </div>
      </div>
    );
  }
}

ZeroState.propTypes = {
  userStore: PropTypes.instanceOf(UserStore),
  gdsUiState: PropTypes.instanceOf(GdsUiState),
  analyticsStore: PropTypes.instanceOf(AnalyticsStore),
};

export default withRouter(ZeroState);
